// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IBillingMethodTypePropertyDto
 */
export interface IBillingMethodTypePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IBillingMethodTypePropertyDto
     */
    billing_method_type?: IBillingMethodTypePropertyDtoBillingMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IBillingMethodTypePropertyDto
     */
    billing_method_type_state?: IBillingMethodTypePropertyDtoBillingMethodTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IBillingMethodTypePropertyDtoBillingMethodTypeEnum {
    PULL_FUNDS = 'PULL_FUNDS',
    PUSH_FUNDS = 'PUSH_FUNDS',
    UNDEFINED = 'UNDEFINED'
}
/**
* @export
* @enum {string}
*/
export enum IBillingMethodTypePropertyDtoBillingMethodTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IBillingMethodTypePropertyDto interface.
 */
export function instanceOfIBillingMethodTypePropertyDto(value: object): value is IBillingMethodTypePropertyDto {
    return true;
}

export function IBillingMethodTypePropertyDtoFromJSON(json: any): IBillingMethodTypePropertyDto {
    return IBillingMethodTypePropertyDtoFromJSONTyped(json, false);
}

export function IBillingMethodTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBillingMethodTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'billing_method_type': json['billing_method_type'] == null ? undefined : json['billing_method_type'],
        'billing_method_type_state': json['billing_method_type_state'] == null ? undefined : json['billing_method_type_state'],
    };
}

export function IBillingMethodTypePropertyDtoToJSON(json: any): IBillingMethodTypePropertyDto {
    return IBillingMethodTypePropertyDtoToJSONTyped(json, false);
}

export function IBillingMethodTypePropertyDtoToJSONTyped(value?: IBillingMethodTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billing_method_type': value['billing_method_type'],
        'billing_method_type_state': value['billing_method_type_state'],
    };
}

